import { getRemoteConfigValues } from '@/lib/remote-config/client';

export const DEFAULT_FULL_SCREEN_PAYWALL_ENABLED = false;

const REMOTE_CONFIG_DEFAULTS = {
  fullScreenPaywallEnabled: String(DEFAULT_FULL_SCREEN_PAYWALL_ENABLED),
} as const;

export const parseFullScreenPaywallEnabled = (
  value: string | null | undefined
): boolean => {
  const normalized = value?.trim().toLowerCase();

  if (normalized === 'true') return true;
  if (normalized === 'false') return false;

  return DEFAULT_FULL_SCREEN_PAYWALL_ENABLED;
};

export const getFullScreenPaywallEnabled = async (): Promise<boolean> => {
  const { fullScreenPaywallEnabled } = await getRemoteConfigValues(
    REMOTE_CONFIG_DEFAULTS
  );

  return parseFullScreenPaywallEnabled(fullScreenPaywallEnabled);
};
